// RespiteSupportSection.js
import React from 'react';
import respiteSupportImage from '../assets/respite-support-image.jpg';

const RespiteSupportSection = () => {
  return (
    <section className="bg-cream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Respite Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Respite Care to Support Both Family Carers and Seniors
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed">
              <p>
                Caring for a loved one can be rewarding, but it can also be physically and emotionally{' '}
                <span className="text-primary font-medium">demanding</span>. At Wei Care, we know how much it means to offer compassionate relief to both family carers and the seniors they look after through our respite care. Our respite care gives carers a temporary break while making sure seniors continue to receive quality care in a safe, nurturing environment.
              </p>

              <p>
                Our respite care services are delivered by our team of trained and compassionate carers who specialise in providing exceptional care to seniors. During the respite period, carers can take time for themselves, attend to personal matters, or simply recharge, knowing that their loved one is in capable and caring hands. To take advantage of our respite care services,{' '}
                <a href="/contact" className="text-primary font-medium hover:text-primary-dark transition-colors">contact us today</a>.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={respiteSupportImage}
              alt="Carer with an older woman"
              className="w-full h-[420px] lg:h-[560px] rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RespiteSupportSection;
